import {
    createSkyNetObjectRoutes,
} from 'app/shared-components/SkyNetObjectProfile/SkyNetObjectRoutes.utils'

import LongTermInvoicesPage from './LongTermInvoices'
import domainConfig from './LongTermInvoices.config'

export default createSkyNetObjectRoutes(<LongTermInvoicesPage />, domainConfig)
